<template>
  <section class="section">
    <div class="container content">
      <h1 class="title">SMS Messaging (Text Messaging) Terms of Service</h1>
      <p>Updated July 15, 2023</p>
      <h2 class="subtitle">How Do We Use SMS Messaging?</h2>
      <p>
        We use SMS messaging to send transactional and informational messages to
        help customers manage their Porsche Auto Insurance policy as follows:
      </p>
      <ul>
        <li>
          We may text you each billing cycle (whether monthly or once per policy
          term) to request updated odometer reading(s) for the vehicles with
          Pay-Per-Mile billing. You may receive a few such requests each cycle,
          starting a few days before your reading is due. When an odometer
          reading is updated and verified, we may send you a confirmation of the
          reading via text message.
        </li>
        <li>
          If your policy has recently expired, been cancelled, or had a vehicle
          removed, we may text you to request final odometer reading(s).
        </li>
        <li>
          If there is a time-sensitive issue with your policy, such as a payment
          that did not go through, we may text you to alert you and provide
          information to help resolve the issue.
        </li>
      </ul>
      <p>
        If you initiate a conversation with us via text message or request that
        we text information you, we may respond via text message.
      </p>
      <p>
        We may send promotional text messages to you from time to time, if you
        opt-in to receive such promotional messages – for example, to retrieve
        or update a quote prior to purchase.
      </p>
      <h2 class="subtitle">How Can I Cancel SMS Messaging?</h2>
      <p>
        You can cancel SMS service at any time by texting "STOP" to us in
        response to a text message. We use different SMS numbers for different
        types of SMS messages, so texting “STOP” will unsubscribe you only from
        that particular service of campaign. After you send the SMS message
        "STOP" to us, we will send you an SMS message to confirm that you have
        been unsubscribed from the service or campaign that you responded to.
      </p>
      <p>If you want to join again, just text the keyword “START” to us.</p>
      <p>
        Please note – because our pay-per-mile policies require you to provide
        periodic odometer readings, we require that you permit us to send
        odometer requests to you by either text or by email. However, we
        recommend you allow both as it helps ensure that you do not forget to
        send your odometer reading, which results in you being charged for the
        maximum default mileage. If you text “STOP” in response to an odometer
        request, you will no longer receive those requests and reminders via
        SMS.
      </p>
      <h2 class="subtitle">What If I Need Help With SMS Messaging?</h2>
      <p>
        If you are experiencing issues our text message system you can reply
        with the keyword HELP for more assistance, or you can get help directly
        by emailing to info@PorscheAutoInsurance.com or calling us at (800)
        400-4128, Monday through Friday from 9 AM to 5 PM.
      </p>
      <h2 class="subtitle">What Else Do I Need to Know?</h2>
      <p>
        Carriers are not liable for delayed or undelivered messages. Our SMS
        services are compatible with most established wireless carriers
        operating in the United States including AT&T, Verizon, T-Mobile, and
        others.
      </p>

      <p>
        As always, message and data rates may apply for any messages sent to you
        from us and to us from you. The number of text messages you receive from
        us will vary. If you have any questions about your text plan or data
        plan, it is best to contact your wireless provider.
      </p>
      <p>
        If you have any questions regarding privacy, please read our privacy
        policy at
        <a href="/legal/privacy-policy"
          >https://www.PorscheAutoInsurance.com/legal/privacy-policy</a
        >.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Sms'
};
</script>

<style lang="scss" scoped>
.bold,
.section-title {
  font-weight: bold;
}
.italic {
  font-style: italic;
}
.underline {
  text-decoration: underline;
}
.sub-text {
  font-size: 0.5rem;
}
table {
  border: solid 1px #000000;

  thead {
    background-color: #000000;
    td {
      text-align: center;
      font-weight: bold;
      color: $white;
    }
  }
  td {
    border: solid 1px #000000;
  }
  td.left {
    font-weight: bold;
    background-color: $grey-light;
    color: $black;
  }
}
</style>
